import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { EntranceTicketType, WithFeatures } from 'apollo/types';
import getApiLanguage from 'i18n/apiLanguage';

const LIST_ENTRANCE_TICKET_TYPES = gql`
  query listEntranceTicketTypes($language: Language) {
    listEntranceTicketTypes(language: $language) {
      adultValue
      description
      id
      maxStock
      name
      otherValue
      status
      isBicycle
      visibility
      entranceImages {
        id
        image
        uploadUrl
      }
      features {
        slug
        name
        availability
        position
        note
      }
    }
  }
`;

const useListEntranceTicketTypesQuery = () => {
  const { i18n } = useTranslation();

  return useQuery<{ listEntranceTicketTypes: WithFeatures<EntranceTicketType>[] }>(
    LIST_ENTRANCE_TICKET_TYPES,
    {
      variables: { language: getApiLanguage(i18n.language) },
    }
  );
};
export default useListEntranceTicketTypesQuery;
